import React, { Component } from 'react'

export class BoardSvg extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={45}
                height={45}
                fill="none"
            >
                <path fill="#fff" d="M5.25 5.25h34.5v24H5.25v-24Z" />
                <path
                    fill="#2E2F46"
                    d="M39.75 30H5.25a.752.752 0 0 1-.75-.75v-24c0-.412.338-.75.75-.75h34.5c.413 0 .75.338.75.75v24c0 .413-.337.75-.75.75ZM6 28.5h33V6H6v22.5Z"
                />
                <path fill="#0064FB" d="M38.25 6.75v21H6.75v-21h31.5Z" />
                <path
                    fill="#fff"
                    d="M38.25 28.5H6.75a.752.752 0 0 1-.75-.75v-21c0-.412.338-.75.75-.75h31.5c.413 0 .75.338.75.75v21c0 .413-.337.75-.75.75ZM7.5 27h30V7.5h-30V27Z"
                />
                <path
                    fill="#2E2F46"
                    d="M30 40.5a.741.741 0 0 1-.705-.495l-3.75-10.5a.752.752 0 0 1 1.417-.502l3.75 10.5a.752.752 0 0 1-.457.96.999.999 0 0 1-.255.037ZM15 40.5a.758.758 0 0 1-.713-1.005l3.75-10.5a.758.758 0 0 1 .96-.457c.39.142.593.57.458.96l-3.75 10.5A.738.738 0 0 1 15 40.5Z"
                />
                <path
                    fill="#2E2F46"
                    d="M27.593 33.75H17.407a.752.752 0 0 1-.75-.75c0-.413.338-.75.75-.75h10.178c.412 0 .75.337.75.75s-.33.75-.742.75Z"
                />
                <path fill="#fff" d="M11.25 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
                <path
                    fill="#fff"
                    d="M11.25 12.75A2.257 2.257 0 0 1 9 10.5a2.257 2.257 0 0 1 2.25-2.25 2.257 2.257 0 0 1 2.25 2.25 2.257 2.257 0 0 1-2.25 2.25Zm0-3a.752.752 0 0 0-.75.75c0 .412.338.75.75.75s.75-.338.75-.75a.752.752 0 0 0-.75-.75Z"
                />
                <path
                    fill="#fff"
                    d="M25.5 11.25H12.75a.752.752 0 0 1-.75-.75c0-.412.338-.75.75-.75H25.5c.413 0 .75.338.75.75s-.337.75-.75.75ZM11.25 18.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
                />
                <path
                    fill="#fff"
                    d="M11.25 19.5A2.257 2.257 0 0 1 9 17.25 2.257 2.257 0 0 1 11.25 15a2.257 2.257 0 0 1 2.25 2.25 2.257 2.257 0 0 1-2.25 2.25Zm0-3a.752.752 0 0 0-.75.75c0 .413.338.75.75.75s.75-.337.75-.75a.752.752 0 0 0-.75-.75Z"
                />
                <path
                    fill="#fff"
                    d="M27.75 18h-15a.752.752 0 0 1-.75-.75c0-.413.338-.75.75-.75h15c.413 0 .75.337.75.75s-.337.75-.75.75ZM11.25 25.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
                />
                <path
                    fill="#fff"
                    d="M11.25 26.25A2.257 2.257 0 0 1 9 24a2.257 2.257 0 0 1 2.25-2.25A2.257 2.257 0 0 1 13.5 24a2.257 2.257 0 0 1-2.25 2.25Zm0-3a.752.752 0 0 0-.75.75c0 .413.338.75.75.75s.75-.337.75-.75a.752.752 0 0 0-.75-.75Z"
                />
                <path
                    fill="#fff"
                    d="M31.5 24.75H12.75A.752.752 0 0 1 12 24c0-.413.338-.75.75-.75H31.5c.413 0 .75.337.75.75s-.337.75-.75.75Z"
                />
            </svg>
        )
    }
}

export default BoardSvg